<template lang="pug">
div(:class='inline ? ["columns", "large-24"] : []' v-if="should_show_active_dates(date)")
    .future-message
        span(v-if="obj.valid_from && obj.valid_until")
          | {{t("app.registration.valid_today.obj_displayed_from_until", {name: t(`app.registration.valid_today.${i18n_klass}`), from_date: l(obj.valid_from, {format: "time.formats.short"}), until_date: l(obj.valid_until,{format: "time.formats.short"})}) }}
        span(v-else-if="obj.valid_from")
          | {{ t("app.registration.valid_today.obj_displayed_from", {name: t(`app.registration.valid_today.${i18n_klass}`), from_date: l(obj.valid_from, {format: "time.formats.short"}) }) }}
        span(v-else-if="obj.valid_until")
          | {{ t("app.registration.valid_today.obj_displayed_until", {name: t(`app.registration.valid_today.${i18n_klass}`), until_date: l(obj.valid_until, {format: "time.formats.short"}) }) }}
</template>
<script>
import helper from "./helper";
import {ValidTodayAbility} from "models/concerns/valid_today_ability"
export default{
  mixins: [helper],
  props: ['obj', 'klass', 'inline'],
  computed: {
    date(){
      this.obj.klass = this.klass
      const o = this.obj.hasOwnProperty('_attributes')  ? this.obj._attributes : this.obj
      return new ValidTodayAbility(o)
    },
    i18n_klass(){
      return this.klass === 'section_option' ? 'sectionoption' : this.klass
    },
  }
}
</script>
